<template>
  <div :class="'mb-2 ' + (row.class ? row.class : '')">
    <div :class="'row ' + (flexStart || row.flexStart ? ' ' : 'flex-end ')">
      <div
        v-for="(input, index) in row.columns"
        v-bind:key="input.name + String(Math.random(1023))"
        :class="
          'col-lg-' +
            (input.colwidth ? input.colwidth : 12 / row.colnum) +
            ' ' +
            (index > 0 ? 'pl-1' : '') +
            ' ' +
            (index < row.columns.length - 1 ? 'pr-1' : '')
        "
      >
        <FormGroup
          :input="input"
          :value="input.value"
          @handleChange="(e) => handleChange(e)"
        />
      </div>
    </div>
  </div>
</template>
<script>
import FormGroup from "./FormGroup.vue";
export default {
  name: "FormRow",
  components: {
    FormGroup,
  },
  props: {
    row: Object,
    flexStart: Boolean,
  },
  data: function() {
    return {};
  },
  methods: {
    handleChange(e) {
      this.$emit("handleChange", e);
    },
  },
};
</script>
